import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.features.set-external-po-numbering.views.external-po-numbering-toggle-card`

export default defineMessages({
  // Angular SETTINGS_CUSTOMIZE_PO_EXTERNAL_PO_NUMBERING copy, sentence-cased
  toggleLabel: {
    id: `${scope}.toggleLabel`,
    defaultMessage: 'Use external PO number for automatically generated POs',
  },
  toggleDescription: {
    id: `${scope}.toggleDescription`,
    defaultMessage:
      'When activated, POs will be created using the external PO number',
  },
  metaDescription: {
    id: `${scope}.metaDescription`,
    defaultMessage:
      'If the external PO number is not set up at activation, the external PO number will be set to start at 1.',
  },
  metaLink: {
    id: `${scope}.metaLink`,
    defaultMessage: 'Click here to view how to set your external PO number',
  },
  toggleAriaLabel: {
    id: `${scope}.toggleAriaLabel`,
    defaultMessage: 'Toggle external PO numbering',
  },
})
